import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-ecfc0a36"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  ref: "modal",
  class: "modal fade",
  tabindex: "-1"
}
const _hoisted_2 = { class: "modal-dialog modal-dialog-scrollable" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = { class: "modal-header" }
const _hoisted_5 = { class: "modal-title" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "btn-close",
  "data-bs-dismiss": "modal",
  "aria-label": "Close"
}, null, -1))
const _hoisted_7 = { class: "modal-body" }
const _hoisted_8 = {
  key: 0,
  class: "alert alert-danger alert-dismissible fade show",
  role: "alert"
}
const _hoisted_9 = {
  key: 0,
  class: "form-floating mb-3"
}
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Identifier", -1))
const _hoisted_11 = { class: "form-floating mb-3" }
const _hoisted_12 = ["disabled"]
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Name", -1))
const _hoisted_14 = { class: "form-floating mb-3" }
const _hoisted_15 = ["disabled"]
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Description", -1))
const _hoisted_17 = {
  key: 1,
  class: "form-floating mb-3"
}
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Created", -1))
const _hoisted_19 = {
  key: 2,
  class: "form-floating mb-3"
}
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Modified", -1))
const _hoisted_21 = { class: "modal-footer" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "btn btn-secondary",
  "data-bs-dismiss": "modal"
}, " Close ", -1))
const _hoisted_23 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("h5", _hoisted_5, _toDisplayString(_ctx.isEditMode ? 'Edit Tag' : 'Create Tag'), 1),
          _hoisted_6
        ]),
        _createElementVNode("div", _hoisted_7, [
          (_ctx.error)
            ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                _createTextVNode(_toDisplayString(_ctx.error) + " ", 1),
                _createElementVNode("button", {
                  class: "btn-close",
                  type: "button",
                  "data-bs-dismiss": "alert",
                  "aria-label": "Close",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.error = undefined))
                })
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("form", null, [
            (_ctx.isEditMode)
              ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                  _withDirectives(_createElementVNode("input", {
                    class: "form-control",
                    placeholder: "Identifier",
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.tag.id) = $event)),
                    disabled: true
                  }, null, 512), [
                    [_vModelText, _ctx.tag.id]
                  ]),
                  _hoisted_10
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_11, [
              _withDirectives(_createElementVNode("input", {
                class: "form-control",
                placeholder: "Name",
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.tag.name) = $event)),
                disabled: _ctx.isEditMode || _ctx.disabled
              }, null, 8, _hoisted_12), [
                [_vModelText, _ctx.tag.name]
              ]),
              _hoisted_13
            ]),
            _createElementVNode("div", _hoisted_14, [
              _withDirectives(_createElementVNode("textarea", {
                class: "form-control",
                placeholder: "Description",
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.tag.description) = $event)),
                disabled: false || _ctx.disabled
              }, null, 8, _hoisted_15), [
                [_vModelText, _ctx.tag.description]
              ]),
              _hoisted_16
            ]),
            (_ctx.isEditMode)
              ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                  _withDirectives(_createElementVNode("input", {
                    class: "form-control",
                    placeholder: "Created",
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.tag.created) = $event)),
                    disabled: true
                  }, null, 512), [
                    [_vModelText, _ctx.tag.created]
                  ]),
                  _hoisted_18
                ]))
              : _createCommentVNode("", true),
            (_ctx.isEditMode)
              ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                  _withDirectives(_createElementVNode("input", {
                    class: "form-control",
                    placeholder: "Modified",
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.tag.modified) = $event)),
                    disabled: true
                  }, null, 512), [
                    [_vModelText, _ctx.tag.modified]
                  ]),
                  _hoisted_20
                ]))
              : _createCommentVNode("", true)
          ])
        ]),
        _createElementVNode("div", _hoisted_21, [
          _hoisted_22,
          _createElementVNode("button", {
            type: "button",
            class: "btn btn-primary",
            onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.isEditMode ? _ctx.updateTag() : _ctx.createTag())),
            disabled: _ctx.disabled
          }, _toDisplayString(_ctx.isEditMode ? 'Update Tag' : 'Create Tag'), 9, _hoisted_23)
        ])
      ])
    ])
  ], 512))
}